import { AppIcon } from '@/components/ui/app-icon';
import { iconLockKeyholeSolid } from '@/lib/icons';
import { cn } from '@/lib/utils';

/**
 * Muted text's colour: over 3:1, as a meaningful graphic needs, on the
 * tabbed sidebar's rail, a tile and the selected card, in either theme.
 */
const LOCK_TONE = 'text-muted-foreground';

/**
 * The lock a locked entry carries after its label, in the tabbed sidebar.
 * Today's sidebar keeps its own upgrade mark (`SidebarNavItem`).
 */
export function LockMark({ className }: { className?: string }) {
  return (
    <AppIcon
      icon={iconLockKeyholeSolid}
      aria-hidden
      data-lock-mark
      className={cn('shrink-0', LOCK_TONE, className)}
      style={{ fontSize: 11 }}
    />
  );
}

/**
 * The lock on a folded entry, where no label shows: a small lock up and to
 * the right of its centred 16px icon, clear of the icon so it needs no
 * cut-out and reads the same on the rail, on a tile and on a selected card.
 * Its 40px cell is the positioning box.
 */
export function LockBadge({ className }: { className?: string }) {
  return (
    <AppIcon
      icon={iconLockKeyholeSolid}
      aria-hidden
      data-lock-mark
      className={cn(
        'pointer-events-none absolute top-1 right-[3px]',
        LOCK_TONE,
        className
      )}
      style={{ fontSize: 9 }}
    />
  );
}
